import { createStyles } from '@mantine/core';

export const useStyles = createStyles((theme) => ({
  dialog: {
    width: 480,

    [theme.fn.smallerThan('sm')]: {
      width: '100%',
    },
  },

  body: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.other.spacing._16,
  },

  title: {
    alignSelf: 'center',
  },

  tabsContainer: {
    display: 'flex',
    gap: theme.other.spacing._8,
  },

  card: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.colors.gray2[0],
    borderRadius: theme.other.spacing._16,
    overflow: 'hidden',
  },

  accordionContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.other.spacing._12,
    paddingBottom: theme.other.spacing._16,
  },

  rules: {
    margin: 0,
    whiteSpace: 'pre-line',
  },
}));
